export const endpoints = {
  auth: {
    login: '/api/auth/login',
    refresh: '/api/auth/refresh',
    logout: '/api/auth/logout'
  },
  events: {
    list: '/api/events',
    byId: (id: string) => `/api/events/${id}`,
    create: '/api/events',
    update: (id: string) => `/api/events/${id}`
  },
  exhibitors: {
    byEvent: (eventId: string) => `/api/exhibitors?eventId=${eventId}`,
    byId: (id: string) => `/api/exhibitors/${id}`,
    create: '/api/exhibitors',
    update: (id: string) => `/api/exhibitors/${id}`,
    delete: (id: string) => `/api/exhibitors/${id}`
  },
  delegates: {
    lookup: (scannedValue: string) => `/api/delegates/lookup?value=${encodeURIComponent(scannedValue)}`,
    byEvent: (eventId: string) => `/api/delegates?eventId=${eventId}`,
    create: '/api/delegates',
    update: (id: string) => `/api/delegates/${id}`,
    exportCsv: (eventId: string) => `/api/delegates/export/csv?eventId=${eventId}`,
    exportXlsx: (eventId: string) => `/api/delegates/export/xlsx?eventId=${eventId}`
  },
  scans: {
    upload: '/api/scans/upload'
  },
  leads: {
    byExhibitor: (exhibitorId: string) => `/api/leads?exhibitorId=${exhibitorId}`,
    upsertNotes: (scanId: string) => `/api/leads/${scanId}/notes`,
    delete: (scanId: string) => `/api/leads/${scanId}`,
    exportMineCsv: '/api/leads/export/mine/csv',
    exportMineXlsx: '/api/leads/export/mine/xlsx',
    exportTeamCsv: (exhibitorId: string) => `/api/leads/export/team/csv?exhibitorId=${exhibitorId}`,
    exportTeamXlsx: (exhibitorId: string) => `/api/leads/export/team/xlsx?exhibitorId=${exhibitorId}`
  },
  users: {
    byEvent: (eventId: string) => `/api/users?eventId=${eventId}`,
    byExhibitor: (exhibitorId: string) => `/api/users/by-exhibitor/${exhibitorId}`,
    create: '/api/users',
    update: (id: string) => `/api/users/${id}`,
    delete: (id: string) => `/api/users/${id}`,
    resetPassword: (id: string) => `/api/users/${id}/reset-password`,
    scanStats: (exhibitorId: string) => `/api/users/by-exhibitor/${exhibitorId}/scan-stats`
  },
  analytics: {
    live: (eventId: string) => `/api/analytics/live?eventId=${eventId}`,
    exportCsv: (eventId: string) => `/api/analytics/export/csv?eventId=${eventId}`,
    exportXlsx: (eventId: string) => `/api/analytics/export/xlsx?eventId=${eventId}`
  },
  dashboard: {
    get: (eventId: string) => `/api/dashboard?eventId=${eventId}`
  }
} as const;